// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Dl8J","title":"Images45_title__2kCMz","images":"Images45_images__3qMky"};